import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import {
  fileUploadBuilderUI,
  triggerEmailBuilderUI
} from './file-upload.mappers';
import { map } from 'rxjs/operators';
import { format } from '@shared/utilities/formatEmail';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {
  baseUrl = environment.apiUrl;

  constructor(private _http: HttpClient) {}
  selectedFile: File;

  uploadFiles(file, userName) {
    const formData = new FormData();
    formData.append('Files', file, file.name);
    return this._http.post(
      `${this.baseUrl}/users/${format(
        userName
      )}/investor-verification/documents`,
      formData,
      {
        reportProgress: true,
        observe: 'events'
      }
    );
  }

  uploadVerificationDetails(userName, data) {
    return this._http
      .post(
        `${this.baseUrl}/users/${format(userName)}/investor-verification`,
        data
      )
      .pipe(map(fileUploadBuilderUI));
  }

  triggerEmail(userName) {
    return this._http
      .post(
        `${this.baseUrl}/users/${format(
          userName
        )}/investor-verification/send-email`,
        ''
      )
      .pipe(map(triggerEmailBuilderUI));
  }
}
